import BASE_API from "../../utility/base-api"

export const NOTIFICATION_ENDPOINT = {
  list: `${BASE_API}/notifications/get-notifications`,
  createNotification: `${BASE_API}/notifications/create-notification`,
  delete: `${BASE_API}/notifications/delete-notification`,
}
